/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Routine } from "./Routine";
export const RoutinesResponse = core.serialization.object({
    data: core.serialization.list(Routine),
});
